import React from "react";
import { osiLayerInfo } from "../data/osiData";

// 계층별 아이콘 추가
const layerIcons = {
  application: "🌐",
  presentation: "🎨",
  session: "🔗",
  transport: "🚀",
  network: "🌍",
  dataLink: "🔧",
  physical: "⚡",
};

const OSILayer = ({ layerKey, highlighted, onHighlight, onClick }) => {
  const layerData = osiLayerInfo[layerKey];

  if (!layerData) return null;

  const layerStyle = {
    margin: "10px 0",
    padding: "15px",
    border: highlighted ? "2px solid #007bff" : "1px solid gray",
    borderRadius: "10px",
    background: highlighted
      ? "linear-gradient(to right, #007bff, #6610f2)"
      : "white",
    color: highlighted ? "white" : "black",
    cursor: "pointer",
    fontSize: "1.5rem",
    fontWeight: "bold",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
    transition: "background 0.3s ease",
  };

  return (
    <div
      style={layerStyle}
      onMouseEnter={() => onHighlight(layerKey)}
      onMouseLeave={() => onHighlight(null)}
      onClick={() => onClick(layerKey)}
    >
      {layerIcons[layerKey]} {layerData.name}
    </div>
  );
};

export default OSILayer;
